import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'absolute',
    width: '400px',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffffff',
    borderRadius: '6px'
  },
  header: {
    color: "white",
    backgroundColor: '#2F49D1',
    padding: '20px',
    borderBottom: '1px solid #EEEEEE',
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  title: {
    fontWeight: 600,
    fontSize: '18px',
    '&.delete': {
      color: '#FF2B2B'
    },
    '&.save': {
      color: '#1A43CC'
    }
  },
  body: {
    padding: '10px 20px',
    fontSize: '16px',
    textAlign: 'center'
  },
  footer: {
    padding: '10px 20px',
    textAlign: 'center'
  },
  cancelBtn: {
    textTransform: 'uppercase',
    fontSize: '14px',
    padding: '5px 30px',
    marginRight: '15px'
  },
  okBtn: {
    color: "white",
    backgroundColor: '#2F49D1',
    textTransform: 'uppercase',
    fontSize: '14px',
    padding: '5px 30px'
  },
  deleteText: {
    color: '#FF2B2B'
  },
  saveText: {
    color: '#1A43CC'
  },
  errorBg: {
    backgroundColor: '#FF2B2B',
    "&:hover": {
      backgroundColor: "#D70000",
      borderColor: "#D70000",
    },
    "&:active": {
      backgroundColor: "#D70000",
      borderColor: "#D70000",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      border:'none',
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    },
  },
  successBg: { 
    backgroundColor: '#1A43CC',
    "&:hover": {
      backgroundColor: "#303f9f",
      borderColor: "#303f9f"
    },
    "&:active": {
      backgroundColor: "#303f9f",
      borderColor: "#303f9f"
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      borderColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none"
    },
  }
}));

export default function StatusModalImportColor({ 
  isOpen,
  onClose,
  title,
  children,
  type,
  okText
}) {
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      open={isOpen}
      onClose={onClose}
    >
      <div className={classes.modal}>
        <div className={`${classes.header} ${classes[`${type}Bg`]}`}>
          <span className={`${classes.title}`}>{title}</span>
        </div>
        <div className={classes.body}>
          {children}
        </div>
        <div className={classes.footer}>
            <Button
              variant="outlined"
              onClick={onClose}
              className={`${classes.okBtn} ${classes[`${type}Bg`]}`}
            >
							{okText}
						</Button>
        </div>
      </div>
    </Modal>
  )
}

StatusModalImportColor.defaultProps = {
  cancelText: 'Huỷ bỏ'
}